import { ZObjState } from "src/types/ZObjState";
import { ZTranslationMap } from "src/types/ZTranslation";
import { ZUid } from "src/types/zUid";
import { ZPermissions } from "./roles/roleTypes";
import { ZLightObject } from "./Obj2Nodes";
import { loadObjectPermissions } from "./roles/rolesApi";
import { EdNotifyTemplateDict } from "./NotifyTemplates/EdNotifyTemplate";
import { EdDelayedNotifyDict } from "./DelayedNotify/EdDelayedNotify";
import { EdReqAttributesDict } from "./RequiredAttributes/EdRequiredAttributes";

export type EdObjStates = Record<string, ZPermissions>; // key = String(ZObjState.id)

/**
 * Тип данных для формы редактирования объекта.
 */
export type EdObject = ZLightObject & {
  rolesMap?: EdObjStates;
  translation?: ZTranslationMap;
  // Актуальный список состояний. Меняется путём добавления/удаления состояний на форме
  states?: ZObjState[];
  templatesMap?: EdNotifyTemplateDict;
  delayedNotifyMap?: EdDelayedNotifyDict;
  requiredAttrsMap?: EdReqAttributesDict;
  disableVersionAudit?: boolean | null;
};

export const obj2edit = (
  obj: ZLightObject,
  states: ZObjState[] | undefined,
  rolesMap: EdObjStates | undefined,
  translation: ZTranslationMap,
  templatesMap: EdNotifyTemplateDict,
  delayedNotifyMap: EdDelayedNotifyDict,
  requiredAttrsMap: EdReqAttributesDict,
  disableVersionAudit: boolean,
): EdObject => ({
  ...obj,
  states,
  rolesMap,
  translation,
  templatesMap,
  delayedNotifyMap,
  requiredAttrsMap,
  disableVersionAudit,
});

export const edit2obj = (
  edit: EdObject,
): {
  lightObject: ZLightObject;
  states: ZObjState[] | undefined;
  rolesMap: EdObjStates | undefined;
  translation: ZTranslationMap | undefined;
  templatesMap: EdNotifyTemplateDict | undefined;
  delayedNotifyMap: EdDelayedNotifyDict | undefined;
  requiredAttrsMap: EdReqAttributesDict | undefined;
  disableVersionAudit: boolean;
} => {
  const {
    rolesMap,
    states,
    translation,
    templatesMap,
    delayedNotifyMap,
    requiredAttrsMap,
    disableVersionAudit,
    ...lightObject
  } = edit;
  return {
    lightObject,
    rolesMap,
    states,
    translation,
    templatesMap,
    delayedNotifyMap,
    requiredAttrsMap,
    disableVersionAudit: disableVersionAudit ?? false,
  };
};

export const makeRolesMap = async (
  objectId: ZUid,
  states: ZObjState[],
): Promise<EdObjStates> => {
  const permissions: ZPermissions[] = await Promise.all(
    states.map(({ id }) => loadObjectPermissions(objectId, id)),
  );
  const res: EdObjStates = {};
  permissions.forEach((permission, i) => {
    res[states[i]!.id] = permission;
  });
  return res;
};
